module.exports = __webpack_public_path__ + "fonts/windows_command_prompt.d7707cea.otf";